<div class="flashcard-mode-container" *ngIf="!loading && dictionary">
  <div class="flashcard-header-row" style="margin-bottom: 60px">
    <mat-icon class="flashcard-header-icon">style</mat-icon>
    <h1 class="flashcard-header">Flash Cards</h1>
  </div>
  <div class="flashcard-title-row-dic">
    <mat-icon class="flashcard-title-icon-dic">auto_stories</mat-icon>
    <h1 class="flashcard-title-dic">{{ dictionary.title }}</h1>
  </div>
  <div class="mode-cards">
    <mat-card
      class="mode-card"
      [class.disabled-card]="dictionary.playable_words_count === 0"
      (click)="dictionary.playable_words_count > 0 && goToFlashcards('words')"
    >
      <div style="display: flex; align-items: center; gap: 10px">
        <mat-icon>fiber_manual_record</mat-icon>
        <mat-card-title>Words</mat-card-title>
      </div>
      <mat-card-content>
        <div class="mode-count">{{ dictionary.playable_words_count }}</div>
        <div class="mode-label">Playable Words</div>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="mode-card"
      [class.disabled-card]="dictionary.playable_pairs_count === 0"
      (click)="dictionary.playable_pairs_count > 0 && goToFlashcards('pairs')"
    >
      <div style="display: flex; align-items: center; gap: 10px">
        <mat-icon>fiber_smart_record</mat-icon>
        <mat-card-title>Pairs</mat-card-title>
      </div>
      <mat-card-content>
        <div class="mode-count">{{ dictionary.playable_pairs_count }}</div>
        <div class="mode-label">Playable Pairs</div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
@if (loading) {
  <ddc-loading-skeleton></ddc-loading-skeleton>
}
<div *ngIf="error">{{ error }}</div>
